// src/menu-items/ports.ts
import { PhoneIncome } from 'iconoir-react';

const ports = {
  id: 'ports-group',
  title: 'Ports',
  type: 'group',
  children: [
    {
      id: 'ports-overview',
      title: 'Number Porting',
      type: 'item',
      url: '/ports/overview',
      icon: PhoneIncome,
      breadcrumbs: true
    }
  ]
};

export default ports;
